var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1020.5 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#9a633e;}.cls-17,.cls-3{opacity:0.4;mix-blend-mode:multiply;}.cls-17,.cls-4{fill:#919497;}.cls-5{fill:#507e0e;}.cls-6{fill:#cd8453;}.cls-7{fill:#6ba813;}.cls-8{fill:#177aa6;}.cls-9{fill:#fff;}.cls-10{fill:#2abfcf;}.cls-11{fill:#5b5862;}.cls-12{fill:#f8b878;}.cls-13{fill:#35d9e2;}.cls-14{fill:#ffcd6c;}.cls-15{fill:#ef5a3c;}.cls-16{fill:#a3392d;}.cls-18{fill:#f6edd0;}.cls-19{fill:#fff4d7;}.cls-20{fill:#f0bb79;}.cls-21{fill:#82210d;}.cls-22{fill:#fcee21;}.cls-23{fill:#93278f;}.cls-24{fill:#ffc452;}.cls-25{fill:#fff7ca;}.cls-26{fill:#f2b655;}.cls-27{fill:#40c2d3;}.cls-28{fill:#82d3e0;}.cls-29{fill:#f4f2e3;}.cls-30{fill:#78191d;}.cls-31{fill:#89b942;}.cls-32{fill:#fc7a22;}.cls-33{fill:#c1b096;}.cls-34{fill:#e2610a;}.cls-35{fill:#58606d;}.cls-36{fill:#bb6f38;}.cls-37{fill:#bdeef4;opacity:0.5;}.cls-38{fill:#6b6160;}.cls-39{fill:#d89655;}.cls-40{fill:#f4a822;}.cls-41{fill:#19cbdd;}.cls-42{fill:#86e7f7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "houses2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.5,147.4c2.5-.9,1.4-4,1.4-7.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M687.4,147.4c.5-1.6.5-4.7.5-7.1C687.4,141.9,687.4,145,687.4,147.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M687.2,117.1c-3.4,0-10.3,25.7,0,25.7S690.6,117.1,687.2,117.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M687.5,117.2c2,4.6,8.3,30.7-5.4,23,.9,3.5,7.7,3.5,9.7,1.2s.4-5.4.3-7.5S691.1,118.5,687.5,117.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.4,147.4c1.8-1,1.7-3.5,1.2-6.3h-1.2A44.2,44.2,0,0,0,671.4,147.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M672.2,147.4a13.4,13.4,0,0,0,0-6.3C672.2,143.1,672,145.3,672.2,147.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M672,120.5c-3.2,0-9.1,22.8,0,22.8S675,120.5,672,120.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M672.2,120.5c1.8,4.1,7.4,27.3-4.8,20.5.9,3.2,6.8,2.9,8.7,1s.3-4.4.3-5.9C676.6,133,675.3,121.6,672.2,120.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M678.9,147.4c2.5-1.2,1.5-4.2,1.5-7.7h-1.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.9,147.4a16.7,16.7,0,0,0,0-7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M679.6,114.7c-3.6,0-11.2,27.8,0,27.7S683.1,114.7,679.6,114.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.9,114.8c2.2,5,8.9,33.1-5.8,24.8,1,3.7,8.4,3.9,10.5,1.3s.5-5.7.3-8S683.9,116.2,679.9,114.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.5,147.4c1.8-1,1.7-3.5,1.3-6.3h-1.3A44.2,44.2,0,0,0,834.5,147.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.4,147.4a13.4,13.4,0,0,0,0-6.3A44.2,44.2,0,0,0,835.4,147.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M835.2,120.5c-3.2,0-9.2,22.8,0,22.8S838.2,120.5,835.2,120.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.4,120.5c1.8,4.1,7.4,27.3-4.8,20.5.9,3.2,6.8,3,8.6,1s.3-4.4.4-5.9C839.8,133,838.5,121.6,835.4,120.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M819.3,147.4c2.4-.9,1.4-4,1.4-7.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820.2,147.4a15.5,15.5,0,0,0,0-7.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M820,117.3c-3.5,0-10.3,25.5,0,25.5S823.3,117.3,820,117.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820.2,117.3c2,4.6,8.3,30.6-5.3,22.9.9,3.5,7.6,3.5,9.6,1.2s.4-5.4.3-7.4S823.9,118.6,820.2,117.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M826.8,147.4c2.5-1.2,1.5-4.2,1.5-7.7h-1.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.8,147.4a16.7,16.7,0,0,0,0-7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M827.6,114.7c-3.7,0-11.2,27.8,0,27.7S831.1,114.7,827.6,114.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.9,114.8c2.2,5,8.9,33.1-5.9,24.8,1,3.7,8.5,3.9,10.5,1.3s.5-5.7.4-8S831.8,116.2,827.9,114.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M662.1,150H824.4c2.6,0,17.8,2,19.6,0,3.4-3.8-13.4-2.6-14.5-2.6H681.8C677.9,147.4,661.4,144.8,662.1,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M702.8,57.7l-20,18.7H823.4c-5.6-5.2-13.5-16.3-20.5-18.7s-21.3,0-29.4,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M718.1,73.3a32.5,32.5,0,0,0,5.4,0l-5.4-7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.4,60.2c-4.7,0-6.6,5.5-5.7,9.4s-.1,3.7,5.7,3.7,4.2.7,5.7-2.4S716.7,60.2,712.4,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M712.4,61.2c-5.6,0-8,11.1,0,11.1S718,61.2,712.4,61.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.2,72.3c.9-2.7.4-7.8.4-11.4C711.7,63.7,712.2,68.8,712.2,72.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M707.7,69.3a72.1,72.1,0,0,0,9.4-.3A72.1,72.1,0,0,0,707.7,69.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M707.7,65.7c3,0,6.7.1,9.4-.2A72.6,72.6,0,0,0,707.7,65.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M758.8,73.3a32.5,32.5,0,0,0,5.4,0l-5.4-7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M753.1,60.2c-4.7,0-6.6,5.5-5.7,9.4s-.2,3.7,5.7,3.7,4.1.7,5.7-2.4S757.4,60.2,753.1,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M753.1,61.2c-5.6,0-8.1,11.1,0,11.1S758.7,61.2,753.1,61.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M752.8,72.3c.9-2.4.8-8.9,0-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M748.4,69.3a72.1,72.1,0,0,0,9.4-.3A70.9,70.9,0,0,0,748.4,69.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M748.4,65.7c3,0,6.7.1,9.4-.2A71.7,71.7,0,0,0,748.4,65.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M799.4,73.3a32.5,32.5,0,0,0,5.4,0l-5.4-7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.7,60.2c-4.6,0-6.6,5.5-5.7,9.4s-.1,3.7,5.7,3.7,4.2.7,5.7-2.4S798,60.2,793.7,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M793.7,61.2c-5.5,0-8,11.1,0,11.1S799.3,61.2,793.7,61.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.5,72.3c.9-2.4.8-8.9,0-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M789,69.3a70.9,70.9,0,0,0,9.4-.3A72.1,72.1,0,0,0,789,69.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M789,65.7c3.1,0,6.8.1,9.4-.2A72.6,72.6,0,0,0,789,65.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M682.8,78H823.4V76.4H750.3C743.3,76.4,683.7,73,682.8,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M689.3,147.4H797.4c4.2,0,12.9,1.8,16.7,0s.7,1.2,2.7-2.2,0-17.2,0-21.7V96.8c0-2.9,2-15.4,0-17.9s-17.2-.9-21.5-.9c-33,0-67.1-2.6-100.1,0-2.5.2-4.7-.6-5.9.9-2.4,3,0,16.7,0,20.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M689.3,81.4H804.1c1.8,0,11.4,1.4,12.7,0,4.5-4.7-9.5-3.4-10.2-3.4H702.9C699.1,78,687.9,75.4,689.3,81.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M699.2,107.3c5.1,0,21.3,2.8,25.1,0,1.3-1,3.6-18.5,1.3-20.4s-23.1-1.3-25.1,0S699.2,102.3,699.2,107.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M700.1,106.5c4.5,0,20.4,2.7,23.7,0,1.1-.8,2.6-17.2.9-18.8s-21.9-1-23.2,0C698.3,90.2,700.1,101.3,700.1,106.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M718.6,106.5c1.2-4.5,1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,92.2c3.7,0,8.8.5,11.8-.4C721,91.8,715.9,91.4,712.9,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,97.3c3.7,0,8.8.4,11.8-.4C721,96.9,715.9,96.5,712.9,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,102.3c3.7,0,8.8.5,11.8-.4C721,101.9,715.9,101.5,712.9,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M700.1,104.6c2.4,7.7,10.3-14,11.5-16.9C704.7,85.8,702.2,99.7,700.1,104.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M700.1,95.1v3.5l4.7-10.9C701.9,88.3,701.4,92.2,700.1,95.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M711.9,107.3c2.9-1.9,1-16.1,1-20.4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M705.8,106.5c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,92.2c3.7,0,8.9.5,11.8-.4C708.2,91.8,703.1,91.4,700.1,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,97.3c3.7,0,8.9.4,11.8-.4C708.2,96.9,703.1,96.5,700.1,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,102.3c3.7,0,8.9.5,11.8-.4C708.2,101.9,703.1,101.5,700.1,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M780.5,107.3c5.2,0,21.4,2.8,25.2,0,1.3-1,3.5-18.5,1.3-20.4s-23.2-1.3-25.2,0S780.5,102.3,780.5,107.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M781.4,106.5c4.5,0,20.5,2.7,23.8,0,1-.8,2.6-17.2.8-18.8s-21.9-1-23.2,0C779.6,90.2,781.4,101.3,781.4,106.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M799.9,106.5c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,92.2c3.7,0,8.8.5,11.8-.4C802.3,91.8,797.2,91.4,794.2,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,97.3c3.7,0,8.8.4,11.8-.4C802.3,96.9,797.2,96.5,794.2,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,102.3c3.7,0,8.8.5,11.8-.4C802.3,101.9,797.2,101.5,794.2,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M781.4,104.6c2.4,7.7,10.3-14,11.6-16.9C786,85.8,783.6,99.7,781.4,104.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M781.4,95.1v3.5l4.7-10.9C783.3,88.3,782.7,92.2,781.4,95.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.3,107.3c2.8-1.9.9-16.1.9-20.4h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M787.2,106.5c1.1-4.5,1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,92.2c3.8,0,8.9.5,11.9-.4C789.6,91.8,784.4,91.4,781.4,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,97.3c3.8,0,8.9.4,11.9-.4C789.6,96.9,784.4,96.5,781.4,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,102.3c3.8,0,8.9.5,11.9-.4C789.6,101.9,784.4,101.5,781.4,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M780.5,137.9c5.2,0,21.4,2.9,25.2,0,1.3-.9,3.5-18.4,1.3-20.3s-23.2-1.3-25.2,0S780.5,133,780.5,137.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M781.4,137.2c4.5,0,20.5,2.7,23.8,0,1-.8,2.6-17.2.8-18.8s-21.9-1-23.2,0C779.6,120.9,781.4,132,781.4,137.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M799.9,137.2c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,122.9H806C803.3,122.1,796.9,122.2,794.2,122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,128c3.7,0,8.8.4,11.8-.4C802.3,127.6,797.2,127.2,794.2,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,133c3.7,0,8.8.5,11.8-.4C802.3,132.6,797.2,132.2,794.2,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M781.4,135.3c2.4,7.7,10.3-14,11.6-16.9C786,116.4,783.6,130.4,781.4,135.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M781.4,125.8v3.5l4.7-10.9C783.3,119,782.7,122.9,781.4,125.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.3,137.9c2.8-1.8.9-16,.9-20.3h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M787.2,137.2c1.1-4.5,1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,122.9c3.8,0,8.9.5,11.9-.4C789.6,122.5,784.4,122.1,781.4,122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,128c3.8,0,8.9.4,11.9-.4C789.6,127.6,784.4,127.2,781.4,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.4,133c3.8,0,8.9.5,11.9-.4C789.6,132.6,784.4,132.2,781.4,133Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M776.4,145.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M778.5,147.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M774.7,81.4c-4.2.2-1.9,30.8-1.9,35.5s-2.7,27.9,2.6,27.2c-3.4-7-.7-21-.7-29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M733.3,147.4h30c9.7,0,9.5,1.3,9.5-7.9V101.9c0-3.2,2.5-21.3,0-23.9s-25.7,0-30,0c-9.7,0-9.5-1.5-9.5,8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733.3,80.1h22.5c1.6,0,19.4.3,17-2.1s-19,0-22.4,0S733.4,75.9,733.3,80.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M746.4,142.5c5.7,0,11.7,1.6,14-2.4.8-1.5,1.2-20.2,0-21.3s-13.1.2-14,1.5C743.8,124,746.4,137.7,746.4,142.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M747.8,128.1c4.5,1.3,8.1-4.1,4.9-7.6C747.6,115,747.8,126.7,747.8,128.1Zm.3-7.4C757.4,118.2,748.1,138.3,748.1,120.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M754.1,128.1c4.4,1.3,8-4.1,4.8-7.6C753.9,115,754.1,126.7,754.1,128.1Zm.2-7.4C763.6,118.2,754.3,138.3,754.3,120.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M747.8,140.8c4.5,1.4,8.1-4.1,4.9-7.6C747.6,127.7,747.8,139.4,747.8,140.8Zm.3-7.3C757.4,131,748.1,151,748.1,133.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M754.1,140.8a4.7,4.7,0,0,0,4.8-7.6C753.9,127.7,754.1,139.4,754.1,140.8Zm.2-7.3C763.6,131,754.3,151,754.3,133.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M747.8,131.9c1.3,0,14.6.9,11.1-2.6S747.6,128.3,747.8,131.9Zm.3-2.4c1.3,0,13.2-.9,10.6,2.1S748.1,132.5,748.1,129.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M741.4,134.6c5.4,1.2,5.6-14.2,3.5-15.8C739.6,114.8,741.4,132.2,741.4,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M741.8,134.2c3.8.4,4.7-12.9,2.6-15.1S741.8,132.5,741.8,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M741.8,122.7c1.3-.2,2,.3,2.6-.5A5.1,5.1,0,0,0,741.8,122.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M741.8,126.9c1.3-.2,2,.3,2.6-.4C743.3,126.2,742.1,126.9,741.8,126.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M741.8,131.1c1.3-.1,2,.3,2.6-.4A6.9,6.9,0,0,0,741.8,131.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M761.7,134.6c5.5,1.2,5.7-14.2,3.6-15.8C759.9,114.8,761.7,132.2,761.7,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M762.2,134.2c3.8.4,4.7-12.9,2.6-15.1S762.2,132.5,762.2,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M762.2,122.7c1.3-.2,2,.3,2.6-.5A5.1,5.1,0,0,0,762.2,122.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M762.2,126.9c1.3-.2,2,.3,2.6-.4C763.7,126.2,762.5,126.9,762.2,126.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M762.2,131.1c1.3-.1,2,.3,2.6-.4A6.9,6.9,0,0,0,762.2,131.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M735.4,142.5c6.1,1.8,4-5.4,4-9.5s1.9-15.5,0-17.4c-4.9-4.7-4,7-4,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M766.8,142.5c6.1,1.8,4-5.4,4-9.5s1.9-15.5,0-17.4c-4.9-4.7-4,7-4,8.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M766.8,116.2c1.7,0,3.2.4,4-.6C769.2,115.3,767.2,116.2,766.8,116.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M735.4,116.2c1.7,0,3.2.4,4-.6C737.8,115.3,735.8,116.2,735.4,116.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M739.4,142.5c3.6-2.6,1-21.8,1-27.6h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M770.8,142.5c3.6-2.6,1-21.8,1-27.6h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M740.4,116.5c5.5,1.1,23.1,3.3,26.4-.9C760.6,115.6,744,113.1,740.4,116.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M771.8,116.5c.6-.6,1.5,1.1,1-.9C771.4,115.2,772.3,116,771.8,116.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M733.3,116.5c1.3-.5,2.1.9,2.1-.9C733.4,115,734,116.2,733.3,116.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M733.3,114.9h22.5c1.2,0,21,.5,17-2.8s-18.6,0-22.4,0S732.4,109.5,733.3,114.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M733.3,115.6h39.5C767,112.5,739.2,112.8,733.3,115.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M733.3,112.1c10.7,0,30.9,3.6,39.5-.7C762.2,111.4,742,107.7,733.3,112.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M763.3,115.6c.2-1.1,1-3,0-4.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M742.8,115.6c2.4,0,25.9,2,20.5-4.2-1.2-1.4-12.7-.1-14.3,0C745.1,111.8,741.3,109.9,742.8,115.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M742.8,116.3c5.1,0,17,1.8,20.5-.7C758.2,115.6,746.3,113.8,742.8,116.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M742.8,111.4c5.1,0,17,1.9,20.5-.6C758.2,110.8,746.3,108.9,742.8,111.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M727.6,147.4h50.9v-1.7C770.9,145.7,728.7,142.5,727.6,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M729.7,145.7h46.7v-1.6C768.9,144.1,731.5,140.6,729.7,145.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M732.4,144.1h41.3v-1.6C766.6,142.5,734.3,139.1,732.4,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M743.1,129.7c-1.8,0-2.6,11.6,0,11.6S744.8,129.7,743.1,129.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M744,134.6c0-2.1,0,7.3-1.9,5.6.9,2.6,4.4-7.9,1-10.4A12.8,12.8,0,0,1,744,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M742.4,142.5c.6-.8,1.9.6,1.6-1.7h-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M742.1,140.8l.3,1.7A7.4,7.4,0,0,0,742.1,140.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M743.5,142.5c0-.3.6-.9.5-1.7S743.7,141.6,743.5,142.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M763.6,129.7c-1.8,0-2.6,11.6,0,11.6S765.3,129.7,763.6,129.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M764.5,134.6c0-2.1,0,7.3-1.9,5.6.8,2.6,4.4-7.9,1-10.4A12.8,12.8,0,0,1,764.5,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M762.8,142.5c.7-.8,2,.6,1.7-1.7h-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M762.6,140.8l.3,1.7C762.9,142,762.6,141.1,762.6,140.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M764,142.5c0-.3.6-.9.5-1.7S764.2,141.6,764,142.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M739.8,107.3c5.2,0,21.4,2.8,25.2,0,1.3-1,3.5-18.5,1.3-20.4s-23.2-1.3-25.2,0S739.8,102.3,739.8,107.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M740.8,106.5c4.5,0,20.4,2.7,23.7,0,1-.8,2.6-17.2.9-18.8s-22-1-23.3,0C738.9,90.2,740.8,101.3,740.8,106.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M759.2,106.5c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M753.5,92.2c3.7,0,8.9.5,11.9-.4C761.6,91.8,756.5,91.4,753.5,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M753.5,97.3c3.7,0,8.9.4,11.9-.4C761.6,96.9,756.5,96.5,753.5,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M753.5,102.3c3.7,0,8.9.5,11.9-.4C761.6,101.9,756.5,101.5,753.5,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M740.8,104.6c2.3,7.7,10.2-14,11.5-16.9C745.3,85.8,742.9,99.7,740.8,104.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M740.8,95.1v3.5l4.7-10.9C742.6,88.3,742,92.2,740.8,95.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M752.6,107.3c2.8-1.9.9-16.1.9-20.4h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M746.5,106.5c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M740.8,92.2c3.7,0,8.8.5,11.8-.4C748.9,91.8,743.8,91.4,740.8,92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M740.8,97.3c3.7,0,8.8.4,11.8-.4C748.9,96.9,743.8,96.5,740.8,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M740.8,102.3c3.7,0,8.8.5,11.8-.4C748.9,101.9,743.8,101.5,740.8,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M699.2,137.9c5.1,0,21.3,2.9,25.1,0,1.3-.9,3.6-18.4,1.3-20.3s-23.1-1.3-25.1,0S699.2,133,699.2,137.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M700.1,137.2c4.5,0,20.4,2.7,23.7,0,1.1-.8,2.6-17.2.9-18.8s-21.9-1-23.2,0C698.3,120.9,700.1,132,700.1,137.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M718.6,137.2c1.2-4.5,1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,122.9h11.8C722,122.1,715.6,122.2,712.9,122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,128c3.7,0,8.8.4,11.8-.4C721,127.6,715.9,127.2,712.9,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.9,133c3.7,0,8.8.5,11.8-.4C721,132.6,715.9,132.2,712.9,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M700.1,135.3c2.4,7.7,10.3-14,11.5-16.9C704.7,116.4,702.2,130.4,700.1,135.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M700.1,125.8v3.5l4.7-10.9C701.9,119,701.4,122.9,700.1,125.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M711.9,137.9c2.9-1.8,1-16,1-20.3h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M705.8,137.2c1.2-4.5,1.1-14.3,0-18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,122.9c3.7,0,8.9.5,11.8-.4C708.2,122.5,703.1,122.1,700.1,122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,128h11.8A29.3,29.3,0,0,0,700.1,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700.1,133c3.7,0,8.9.5,11.8-.4C708.2,132.6,703.1,132.2,700.1,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M645.6,135.2c-3.8,0-3.8,5.8,0,5.8S649.4,135.2,645.6,135.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M648,138.1c-3.8,0-3.8,5.9,0,5.9S651.8,138.1,648,138.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M649.7,142.4c-3.8,0-3.8,5.8,0,5.8S653.5,142.4,649.7,142.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M652.7,143.6c-3.8,0-3.8,5.9,0,5.9S656.5,143.6,652.7,143.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M650.9,140.8c-3.8,0-3.8,5.9,0,5.9S654.7,140.8,650.9,140.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.2,147.4c2.2-1.3,1.4-4.4,1.4-7.8h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.1,147.4a20.5,20.5,0,0,0,0-7.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.9,112.9c-8.9,0-9.1,29.6,0,29.6S530.8,112.9,521.9,112.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.7,113.1c2.6,4.1,4.5,30.4-4.4,26.5C524.4,149.5,535.6,118.5,522.7,113.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M531.7,147.3c3.1.2,4.4-9.8,2.4-11.7S531.7,145.9,531.7,147.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M533.3,147.3c1.5-1.9,1.4-9.8,0-11.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M532.9,119.9c-12.7,0-12.7,19.8,0,19.9S545.8,119.9,532.9,119.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.5,121.7c6,8.7-5,19.7-13.8,13.8C533.3,148,551.2,130.4,538.5,121.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M576.5,147.4h56c1.9,0,9.3,1.2,11,0s.1-.3,1.3-3.3,1.7-25.3,0-26.9-16.5,0-19.4,0H588.8c-6,0-10.2-1.6-12.3,2.5C573.5,125.9,576.5,140.4,576.5,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M576.5,93.2c0,4.4-2.6,21.6.2,24.1s16.8,0,20.2,0h54.9c-4.6-6.5-8.7-14.7-14.2-20.4s-4.6-3.7-11.7-3.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.5,119.8h60.1c.8,0,11.5,1.1,8.2-2.7-1-1-9.9,0-11.2,0H609.3C604.4,117.1,576,114.5,576.5,119.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.5,93.2c0,5.8-1.1,12.9,0,18.7s-.3,5.4,7.8,5.4C582.6,111.4,581.1,96,576.5,93.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M604.2,147.4c5.8,0,10.9,1.8,12.9-2.5.8-1.6,1.2-18,0-19.4s-12,.4-12.9,1.7C601.8,130.8,604.2,142.9,604.2,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M606.2,145.8c1.8,0,7.4,1.1,8.5,0s1.3-5.6.5-6.4-7.6-.4-8.1,0S605.9,143.5,606.2,145.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M606.2,133.6c1.8,0,7.4,1,8.5,0s1.3-5.7.5-6.5-7.6-.4-8.1,0S605.9,131.2,606.2,133.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M606.2,137.8C626,137.8,605.8,132.2,606.2,137.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M581.2,137.8c2.9,0,14,1.7,15.8,0s1.7-11.2.6-12.3-15-.7-15.8,0S581.2,134.8,581.2,137.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M582.1,137c2.5,0,12.2,1.6,13.9,0s1.7-9.7.7-10.7-13.4-.4-13.9,0S582.1,134.2,582.1,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M585.7,137c6.1,1.8,7-6.5,8.9-10.7C588.5,124.5,587.5,132.8,585.7,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M582.1,136c2.3,1.6,4.2-6.3,5.7-9.7C584.5,126.8,583.5,132.9,582.1,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M623.7,137.8c2.9,0,14,1.7,15.8,0s1.7-11.2.5-12.3-14.9-.7-15.7,0S623.7,134.8,623.7,137.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M624.6,137c2.5,0,12.2,1.6,13.9,0s1.7-9.7.7-10.7-13.5-.4-13.9,0S624.6,134.2,624.6,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M628.6,137c6,1.8,7-6.5,8.8-10.7C631.3,124.5,630.4,132.8,628.6,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M624.6,136c2.3,1.6,4.2-6.3,5.7-9.7C627,126.8,625.9,132.9,624.6,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M584.8,143.7c-.8.5-.8.9,0,1.4S585.7,144.2,584.8,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M585.7,143.2c-.9.4-.9.9,0,1.3S586.6,143.6,585.7,143.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M585.8,143.5c-.9.5-.9.9,0,1.4S586.7,144,585.8,143.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M586.6,143.4c-.9.5-.9.9,0,1.4S587.5,143.9,586.6,143.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M587,143.6c.4.5-.4,1.3-.9.9S587.7,144.1,587,143.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M587.5,143.8c-.8.5-.8.9,0,1.4S588.4,144.3,587.5,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M588.5,143.5c-.8.5-.8.9,0,1.4S589.4,144,588.5,143.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M589.1,143.7c-.9.5-.9.9,0,1.4S590,144.2,589.1,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M590.2,143.7c-.9.5-.9.9,0,1.4S591,144.2,590.2,143.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.5,143.9c.3.4-.5,1.2-.9.9S590.2,144.4,589.5,143.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M590.2,143.3c-.8.5-.8.9,0,1.3S591.1,143.8,590.2,143.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M591.2,143.7c-.9.5-.9.9,0,1.4S592,144.2,591.2,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592,143.7c-.9.5-.9.9,0,1.4S592.9,144.2,592,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592,143.4c-.9.5-.9.9,0,1.4S592.9,143.9,592,143.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M592.4,143.6c.4.5-.4,1.3-.9.9S593.1,144.1,592.4,143.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.8,143.9c-.9.4-.9.9,0,1.3S593.6,144.3,592.8,143.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.6,143.7c-.9.5-.9.9,0,1.4S594.5,144.2,593.6,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M595.2,143.7c-.9.4-.9.9,0,1.3S596.1,144.1,595.2,143.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M595.7,144.2c0,.4-1.8.8-.5.8S595.7,143.3,595.7,144.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.4,143.4c-.9.5-.9.9,0,1.4S594.3,143.9,593.4,143.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M594.5,143.8c-.8.5-.8.9,0,1.4S595.4,144.3,594.5,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M593.2,143.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M594.4,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M592.9,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M591.9,143.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M590.8,143.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M590.1,143.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M589.6,143.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M591.1,144.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M588.4,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M588.6,143.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M586.8,143.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M585.6,143.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M586.6,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M584.8,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M583.9,147.4c4.1,0,12.1,2.3,12.6-2.7H583.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M595.3,147.4c.2-.6,1.2-1.4,1.2-2.7C595.5,145.2,595.8,146,595.3,147.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.5,147.4c8.3,0,8.3,1.2,8.3-7.2,0-3.2,2.1-18.2,0-20.4-.5-.5-7.8-.5-8.3,0s.1,4.8,0,6C575.9,132.9,576.5,140.3,576.5,147.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M539,93.2v24.4c0,5.4-3.2,24,0,28.3s35,3.8,37.5.4,0-23.5,0-28.7,2.6-19,0-24.2c-1.2-2.5-15.6-13.1-18.4-13.3C553.5,79.8,543.1,90.3,539,93.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M539,94c-.2,2.1,0,4.3,0,6.4,4.1-3.1,14.3-14.4,19.3-14.7s14.4,10.8,18.2,13.7c1.8-6.2-12.6-17.8-18-18.1S543.5,90.9,539,94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M529,98.4c.5,1.5,2.4,3.1,3.4,4.4,5.7-4.3,19.9-19.3,26.2-18.6s23.3,26.4,27.9,14.2l-14.4-11c-2.4-1.8-11.3-11-14.4-10.9s-10.8,8.2-13.3,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M545.5,137.8c5.6,0,15.3,1.9,20.4,0s1.3,1.5,3.2-2.5c.4-.7.8-9,0-9.8s-17.4-.5-19.4,0c-3.8,1.1-2.7-.8-4.2,1.6S545.5,135.6,545.5,137.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M546.4,137c5,0,13.8,1.7,18.4,0s1.7,1.1,3.4-1.8c.4-.6.5-8.3,0-8.9s-15-.5-17.3,0C544.2,128,546.4,128.7,546.4,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M550,137c6,1.8,7-6.5,8.8-10.7C552.7,124.5,551.8,132.8,550,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M546.4,136c2.3,1.6,4.2-6.3,5.6-9.7C548.7,126.8,547.7,132.9,546.4,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M557.1,137a32,32,0,0,0,0-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M545.5,113.4h15.8c7.4,0,7.8,1.5,7.8-6.1s.2-5.9-6.6-6.1-11.4,0-17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M546.4,112.6h21.8c0-11.5.6-10.7-10.9-10.7S546.4,100.9,546.4,112.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M550,112.6c6,1.8,7-6.5,8.8-10.7C552.7,100.1,551.8,108.4,550,112.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M546.4,111.6c2.3,1.6,4.2-6.3,5.6-9.7C548.7,102.4,547.7,108.5,546.4,111.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M557.1,112.6c.6-2.8.4-7.3.4-10.7C556.9,104.7,557.1,109.2,557.1,112.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M637.9,144.1c-5.3,0,0,4.7,0,4.7S643.2,144.1,637.9,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M640.2,142.7c-5.3,0,0,4.7,0,4.7S645.6,142.7,640.2,142.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M641.7,144.1c-5.3,0,0,4.7,0,4.7S647,144.1,641.7,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M645.6,144.1c-5.3,0,0,4.7,0,4.7S651,144.1,645.6,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M643.9,141c-5.4,0,0,4.8,0,4.7S649.2,141,643.9,141Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.8,144c1.8,2.3-1.1,5.3-3.5,3.8C641.7,150.9,646.2,146.2,642.8,144Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M646.8,141.9c-5.4,0,0,4.7,0,4.6S652.1,141.9,646.8,141.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M648,145.1c-5.4,0,0,4.7,0,4.6S653.3,145.1,648,145.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M645.6,139.3c-5.3,0,0,4.7,0,4.7S651,139.3,645.6,139.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M648.9,145.2c.6-1.3-1.5-5.9-3.3-5.9,1.9,1.1,4.8,10,1.2,10.1C649.4,150.9,652.1,146.6,648.9,145.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M509.4,150H646c2.2,0,15,1.7,16.6,0,3.6-3.7-11.5-2.6-12.4-2.6H526C522.3,147.4,508.7,144.9,509.4,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1000.7,147.4c3.1,0,4-8.9,2.2-10.5S1000.7,146.1,1000.7,147.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1002.2,147.4c1.1-2.1,1.1-8.4,0-10.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1003,122.9c-11.4-1.5-13.6,16.1-2.3,17.7S1014.3,124.3,1003,122.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1006.8,124.3c5.4,7.9-4.5,17.8-12.4,12.4C1002.1,148,1018.1,132.1,1006.8,124.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M851.2,147.6c3.1.2,4.4-9.7,2.4-11.7S851.2,146.2,851.2,147.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M852.7,147.6c1.6-1.9,1.4-9.7,0-11.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M852.4,120.3c-12.8,0-12.7,19.7,0,19.8S865.2,120.3,852.4,120.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M858,122c5.9,8.7-5.1,19.8-13.8,13.8C852.7,148.3,870.7,130.7,858,122Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1005.8,147.4c3.2.2,4.4-9.8,2.4-11.7S1005.8,146,1005.8,147.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1007.4,147.4c1.6-1.9,1.4-9.8,0-11.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1007,120c-12.7,0-12.7,19.8,0,19.9S1019.9,120,1007,120Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1012.6,121.8c6,8.7-5,19.7-13.8,13.7C1007.4,148.1,1025.4,130.5,1012.6,121.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M866.1,147.4c14.4,0,30.6,2.2,44.8,0,6.4-1,5.4.9,5.4-6.8,0-3.7,2.5-20,0-22.6s-14.6,0-16.9,0c-8.9,0-18-.6-26.9,0-7.1.5-6.4-.9-6.4,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M866.1,147.4h29.3c1.8,0,27.4,2.5,20.9-5.2-2.5-3-25.5,0-29.2,0C881.5,142.2,863.2,138.2,866.1,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,124.2h37.4v-1.3C903.3,122.9,875.3,119.6,872.7,124.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,126.6h37.4v-1.2C903.3,125.4,875.3,122.1,872.7,126.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,129.1h37.4v-1.3C903.3,127.8,875.3,124.5,872.7,129.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,131.5h37.4v-1.2C903.3,130.3,875.3,127,872.7,131.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,133.9h37.4v-1.2C903.3,132.7,875.3,129.4,872.7,133.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,136.4h37.4v-1.2C903.3,135.2,875.3,131.8,872.7,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,138.8h37.4v-1.2C903.3,137.6,875.3,134.3,872.7,138.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,141.3h37.4V140C903.3,140,875.3,136.7,872.7,141.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,143.7h37.4v-1.2C903.3,142.5,875.3,139.2,872.7,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M872.7,146.2h37.4v-1.3C903.3,144.9,875.3,141.6,872.7,146.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,122.9h37.4v-1.2C903.3,121.7,875.3,118.4,872.7,122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,125.4h37.4v-1.2C903.3,124.2,875.3,120.8,872.7,125.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,127.8h37.4v-1.2C903.3,126.6,875.3,123.3,872.7,127.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,130.3h37.4v-1.2C903.3,129.1,875.3,125.7,872.7,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,132.7h37.4v-1.2C903.3,131.5,875.3,128.2,872.7,132.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,135.2h37.4v-1.3C903.3,133.9,875.3,130.6,872.7,135.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,137.6h37.4v-1.2C903.3,136.4,875.3,133.1,872.7,137.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,140h37.4v-1.2C903.3,138.8,875.3,135.5,872.7,140Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,142.5h37.4v-1.2C903.3,141.3,875.3,137.9,872.7,142.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,144.9h37.4v-1.2C903.3,143.7,875.3,140.4,872.7,144.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M872.7,147.4h37.4v-1.2C903.3,146.2,875.3,142.8,872.7,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M872.7,147.4c3.5-2.6,1-21.3,1-26.9h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M909.1,147.4c3.5-2.6,1-21.3,1-26.9h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M872.7,121.7h37.4v-1.2C903.3,120.5,875.3,117.2,872.7,121.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M866.1,120.2h29.3c2.5,0,23.2.1,20.9-2.2s-21.9,0-26.5,0S866.6,115.7,866.1,120.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M873.7,121.9c0,7.5-1.8,19.1.5,25.5,0-6.2-2.5-22.6,1.7-25.2s14.6,0,18.5,0h14.7C900.3,119.4,883.2,120.9,873.7,121.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M910.1,147.4c2.6-3,2.4-22.5,0-26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M916.3,147.3h65.1c9.2,0,12.4,3,13.3-5.7.4-4.8,3-27.9,0-30.8s-19.3,0-22.9,0H929.6c-2.5,0-9-1.3-11.3,0s-.3-.7-2,3.8C913.2,123,916.3,138.2,916.3,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M946.7,136.4c3.1,0,15.5,2,17.6,0s1.1-15,.2-15.9-16.5-.7-17.3,0S946.7,133.1,946.7,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M947.2,136.4c6.8,2,9-11.1,11.1-15.9C951.4,118.6,949.3,131.6,947.2,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M946.7,128v3.4l4.7-10.9C948.6,121.1,948,125.1,946.7,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M946.4,136.8c3.2,0,16.1,2.1,18.2,0s1.2-15.6.3-16.7-17.2-.7-18,0S946.4,133.4,946.4,136.8Zm.7-15.9c3.2,0,14.5-2,16.8,0s1.1,14.4.2,15.2-15.7.6-16.5,0S947.1,124,947.1,120.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M971,136.4c3.1,0,15.6,2,17.7,0s1.1-15,.2-15.9-16.6-.7-17.4,0S971,133.1,971,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M971.4,136.4c6.8,2,9-11.1,11.1-15.9C975.6,118.6,973.5,131.6,971.4,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M971,128v3.4l4.7-10.9C972.8,121.1,972.2,125.1,971,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M970.6,136.8c3.3,0,16.1,2,18.3,0s1.7-15.3.4-16.7-16.5-.8-17.7,0S970.6,132.7,970.6,136.8Zm.7-15.9c3.2,0,14.8-2,17,0s1.1,14.3.3,15.2-16,.6-16.8,0S971.3,124.1,971.3,120.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M922.7,142.2c5.7,0,9.9,1.6,11.9-2.5.7-1.5,1.2-18,0-19.2s-11,.4-11.9,1.6C920.4,125.6,922.7,137.8,922.7,142.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M924.7,137c3.6,0,6.5.8,7.9-1.4.4-.5.9-11.5,0-12.4s-7.5.2-7.9.6S924.7,135.1,924.7,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M925,137c6.9,1.8,8.1-8.9,7.6-13.8C928.8,123.5,926.5,133.5,925,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M924.7,128.3v3.5l3.7-8.6C926.3,123.7,925.1,125.7,924.7,128.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M919.9,136.3c-4,0,0,4.3,0,4.1S924,136.3,919.9,136.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M920.2,136.4c2.3,1.4,1,4.1-1.3,3.7C921.2,141.7,922.9,137.6,920.2,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M919.1,142.2c1.1-.8,2.3.6,2.1-2h-2.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M918.8,140.2a11.8,11.8,0,0,0,.4,2A10.1,10.1,0,0,0,918.8,140.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M920.5,142.2a5,5,0,0,0,.7-2C920.3,140.6,920.8,141.1,920.5,142.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M916.3,147.4H984c1.7,0,13.1.6,7.5-5.2-1.4-1.4-11.4,0-13.4,0H924.7C920.1,142.2,913.9,140.2,916.3,147.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M916.3,142.2c15.2,0,5.3-1.8,9.8-12.6,1.8-4.5-1.2-1.1,2.2-3s8,0,10.1,0H970c4.3,0,20.3,2.7,23.7,0,1.2-.9,2.1-4.5,1-6.6s.7-.2-3.1-2c-5.8-2.6-18.8,0-25,0H916.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M991.5,147.4c5.5,1.2,3.2-8.2,3.2-12s1.9-15.4,0-17.4c-4.3-4.3-3.2,9.7-3.2,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M944.2,133.1h25c5,0,19.2,2,22.3-.9h-25C961.5,132.2,947.3,130.2,944.2,133.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M945.7,142.1a27.2,27.2,0,0,0,0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M949,142.2a23.2,23.2,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M952.4,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M955.8,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M959.2,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M962.5,142.2a23.2,23.2,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M965.9,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M969.3,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M982.8,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M979.4,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M976,142.2a23.2,23.2,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M972.7,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M986.2,142.2a27.8,27.8,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M989.5,142.2a23.2,23.2,0,0,0,0-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M941,147.4c5.5,1.2,3.2-8.3,3.2-12s2-15.4,0-17.4c-4.3-4.3-3.2,9.6-3.2,10.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M991.5,120.2C997.4,119.9,992.9,115.9,991.5,120.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M919.8,143.9c2.6,0,19.3.6,17.8-1.7S920,141.6,919.8,143.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M919.8,145.6c2.6,0,19.3.7,17.8-1.7S920,143.3,919.8,145.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M919.8,147.4c2.6,0,19.3.6,17.8-1.8S920,145.1,919.8,147.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.8,147.4c.1-.5,1.1-1,0-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.8,145.6c.4-.6,1.8.5,1.2-1.7h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.8,143.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M941,120.2C947,119.9,942.4,115.9,941,120.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M937.4,136.3c-2.2,0-2.6,4.3,0,4.1S939.5,136.3,937.4,136.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M937.7,136.4c2.2,1.4,1,4.1-1.4,3.7C938.6,141.7,940.3,137.6,937.7,136.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M936.6,142.2c1.1-.8,2.3.6,2-2h-2.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M936.2,140.2a17.7,17.7,0,0,1,.4,2A10.1,10.1,0,0,0,936.2,140.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.9,142.2a5,5,0,0,0,.7-2C937.7,140.6,938.2,141.1,937.9,142.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M949.9,130.5c-.8.5-.8.9,0,1.3S950.8,131,949.9,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M950.8,130c-.9.4-.9.8,0,1.3S951.7,130.4,950.8,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M950.9,130.3c-.9.5-.9.9,0,1.3S951.8,130.8,950.9,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M951.7,130.2c-.9.5-.9.9,0,1.3S952.6,130.7,951.7,130.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M952.1,130.4c.4.4-.4,1.2-.9.9S952.8,130.9,952.1,130.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.6,130.6c-.8.4-.8.9,0,1.3S953.5,131,952.6,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M953.6,130.3c-.8.5-.8.9,0,1.3S954.5,130.8,953.6,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M954.2,130.5c-.9.5-.9.9,0,1.3S955.1,131,954.2,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M955.3,130.5c-.9.5-.9.9,0,1.3S956.1,131,955.3,130.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M954.6,130.6c.3.5-.5,1.3-.9.9S955.3,131.1,954.6,130.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M955.3,130.1c-.8.4-.8.9,0,1.3S956.2,130.5,955.3,130.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M956.3,130.5c-.9.5-.9.9,0,1.3S957.1,131,956.3,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M957.1,130.5c-.9.5-.9.9,0,1.3S958,131,957.1,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M957.1,130.2c-.9.5-.9.9,0,1.3S958,130.7,957.1,130.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M957.5,130.4c.4.4-.4,1.2-.9.9S958.2,130.9,957.5,130.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M957.9,130.7c-.9.4-.9.9,0,1.3S958.7,131.1,957.9,130.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M958.7,130.5c-.9.5-.9.9,0,1.3S959.6,131,958.7,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M960.3,130.4c-.9.5-.9.9,0,1.4S961.2,130.9,960.3,130.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M960.8,131c0,.4-1.8.8-.5.8S960.8,130.1,960.8,131Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M958.5,130.2c-.9.5-.9.9,0,1.3S959.4,130.7,958.5,130.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M959.6,130.6c-.8.4-.8.9,0,1.3S960.5,131,959.6,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M958.3,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M959.5,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M958,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M957,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M955.9,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M955.2,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M954.7,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M956.2,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M953.5,130.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M953.7,130.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M951.9,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M950.7,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M951.7,130.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M949.9,130.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M949,134.1c4.1,0,12.1,2.3,12.6-2.7H948.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M960.4,134.1c.2-.5,1.2-1.3,1.2-2.7C960.6,132,960.9,132.8,960.4,134.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M975.8,130.5c-.8.5-.8.9,0,1.3S976.7,131,975.8,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M976.7,130c-.9.4-.9.8,0,1.3S977.6,130.4,976.7,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M976.8,130.3c-.9.5-.9.9,0,1.3S977.7,130.8,976.8,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M977.6,130.2c-.9.5-.9.9,0,1.3S978.5,130.7,977.6,130.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M978,130.4c.4.4-.4,1.2-.9.9S978.7,130.9,978,130.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M978.5,130.6c-.8.4-.8.9,0,1.3S979.4,131,978.5,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M979.5,130.3c-.8.5-.8.9,0,1.3S980.4,130.8,979.5,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M980.1,130.5c-.9.5-.9.9,0,1.3S981,131,980.1,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M981.2,130.5c-.9.5-.9.9,0,1.3S982,131,981.2,130.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M980.5,130.6c.3.5-.5,1.3-.9.9S981.2,131.1,980.5,130.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M981.2,130.1c-.8.4-.8.9,0,1.3S982.1,130.5,981.2,130.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M982.2,130.5c-.9.5-.9.9,0,1.3S983,131,982.2,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M983,130.5c-.9.5-.9.9,0,1.3S983.9,131,983,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M983,130.2c-.9.5-.9.9,0,1.3S983.9,130.7,983,130.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M983.4,130.4c.4.4-.4,1.2-.9.9S984.1,130.9,983.4,130.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M983.8,130.7c-.9.4-.9.9,0,1.3S984.6,131.1,983.8,130.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M984.6,130.5c-.9.5-.9.9,0,1.3S985.5,131,984.6,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.2,130.4c-.9.5-.9.9,0,1.4S987.1,130.9,986.2,130.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M986.7,131c0,.4-1.8.8-.5.8S986.7,130.1,986.7,131Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M984.4,130.2c-.9.5-.9.9,0,1.3S985.3,130.7,984.4,130.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M985.5,130.6c-.8.4-.8.9,0,1.3S986.4,131,985.5,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M984.2,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M985.4,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M983.9,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M982.9,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M981.8,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M981.1,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M980.6,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M982.1,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M979.4,130.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M979.6,130.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M977.8,130.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M976.6,130.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M977.6,130.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M975.8,130.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M974.9,134.1c4.1,0,12.1,2.3,12.6-2.7H974.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M986.3,134.1c.2-.5,1.2-1.3,1.2-2.7C986.5,132,986.8,132.8,986.3,134.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M868.6,101.9,856.3,118h147.4c-5.6-7.4-8.3-15-17.2-16.1-13.4-1.6-27.9,0-41.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M859.5,118c4.4-4.8,8.3-10.8,12.3-16.1C867.5,106.8,863.5,112.6,859.5,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M865.9,118c4-4.8,7.5-10.8,11.2-16.1C873.1,106.8,869.5,112.6,865.9,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M872.3,118c3.6-4.8,6.8-10.8,10.1-16.1C878.7,106.8,875.5,112.7,872.3,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M878.6,118c3.4-4.7,6.2-10.8,9-16.1C884.3,106.7,881.5,112.7,878.6,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M885,118c3.1-4.7,5.4-10.8,7.9-16.1C889.9,106.7,887.5,112.7,885,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M891.4,118c2.7-4.7,4.7-10.8,6.8-16.1C895.6,106.7,893.5,112.7,891.4,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M897.7,118c2.4-4.7,4-10.9,5.8-16.1C901.2,106.7,899.6,112.7,897.7,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M904.1,118c2.1-4.7,3.3-10.9,4.7-16.1C906.8,106.7,905.6,112.7,904.1,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M910.4,118c1.8-4.7,2.6-10.9,3.7-16.1C912.4,106.7,911.6,112.7,910.4,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M916.8,118c1.5-4.7,1.9-10.9,2.6-16.1C918,106.7,917.6,112.8,916.8,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M923.2,118c1.2-4.7,1.1-10.9,1.5-16.1C923.7,106.7,923.6,112.8,923.2,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M929.5,118c.9-4.7.5-11,.5-16.1C929.3,106.7,929.6,112.8,929.5,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M935.1,101.9c.3,5.2,0,11.4,1,16.1C935.9,112.7,936,106.7,935.1,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M940.4,101.9c.6,5.2.8,11.4,2.1,16.1C941.9,112.7,941.6,106.7,940.4,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M945.7,101.9c1,5.2,1.5,11.4,3.2,16.1C947.9,112.7,947.2,106.7,945.7,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M951,101.9c1.3,5.3,2.3,11.4,4.2,16.1C953.9,112.7,952.9,106.7,951,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M956.3,101.9c1.6,5.2,3,11.4,5.3,16.1C959.9,112.7,958.5,106.7,956.3,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M961.6,101.9c2,5.3,3.8,11.4,6.4,16.1C965.9,112.7,964.1,106.7,961.6,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M966.9,101.9c2.4,5.3,4.5,11.3,7.4,16.1C971.9,112.7,969.7,106.8,966.9,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M972.2,101.9c2.7,5.3,5.3,11.3,8.5,16.1C977.9,112.7,975.3,106.8,972.2,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M977.5,101.9c3,5.3,5.9,11.5,9.5,16.1C984,112.7,981.1,106.7,977.5,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M982.8,101.9c3.4,5.3,6.6,11.5,10.6,16.1C990,112.7,986.7,106.6,982.8,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M988.1,101.9c3.7,5.3,7.4,11.5,11.7,16.1C996,112.7,992.3,106.7,988.1,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M941,70.9,910.3,81.6c-13,4.6-12.9,3.1-12.9,16.9,0,9.9-2.9,12.3,6.7,12.3h38.3c11.7,0,25.4,2,37,0,.9-.1,4.5.7,5.2,0s0-12.8,0-14.9c0-12.2-1.2-10.2-12.9-14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M941,75c-7.1,0-7.1,11.1,0,11.1S948.3,75,941,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M941,74.6c-7.6,0-7.6,11.9,0,11.9S948.8,74.6,941,74.6Zm0,11.2c-6.6,0-6.6-10.4,0-10.4S947.8,85.8,941,85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M890.3,82.3c.6,10.7,15.4,1,21.2-1.1,8.2-2.8,20.8-10.3,29.5-10.3s21.3,7.5,29.5,10.3c5.8,2.1,20.6,11.8,21.2,1.1L965,72.8c-6.8-2.4-16.8-8.6-24-8.6s-17.2,6.2-24,8.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M897.4,86.1v2.4l21.4-7.4c6.5-2.3,16.8-8.3,23.8-8.3s13.4,4.5,18.5,6.3l23.5,8.2c-1.4-3.9-13.8-6-17.9-7.4-7-2.5-18-9-25.5-8.9s-14.8,5-20.7,7.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M902.3,106.4c4.5,0,17.6,2.4,20.9,0,1.1-.8,2.8-14.5,1.1-15.9s-19.2-.9-20.4,0C900.9,92.8,902.3,101.3,902.3,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M902.7,106.4c6.8,1.9,9-11.1,11.1-15.9C907,88.5,904.8,101.6,902.7,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M902.3,97.9v3.5L907,90.5C904.1,91.1,903.5,95,902.3,97.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M901.9,106.8c4.6,0,17.7,2.4,21.3,0,1.4-1,3.7-14.4,1.4-16.7s-19.9-.9-21.2,0C900.3,92.3,901.9,102,901.9,106.8Zm.8-16c4.3,0,17-2.3,20.2,0,1,.8,2.7,13.8,1,15.2s-18.5.9-19.7,0C901.3,103.8,902.7,95.6,902.7,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M930,106.4c4.5,0,17.6,2.4,21,0,1-.8,2.7-14.5,1-15.9s-19.2-.9-20.4,0C928.6,92.8,930,101.3,930,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M930.4,106.4c6.9,1.9,9.1-11.1,11.1-15.9C934.7,88.5,932.5,101.6,930.4,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M930,97.9v3.5l4.7-10.9C931.8,91.1,931.2,95,930,97.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M929.6,106.8c4.7,0,17.7,2.4,21.3,0,1.5-1,3.7-14.4,1.5-16.7s-20-.9-21.3,0C928,92.3,929.6,102,929.6,106.8Zm.8-16c4.3,0,17-2.3,20.2,0,1.1.8,2.7,13.8,1,15.2s-18.5.9-19.6,0C929,103.8,930.4,95.6,930.4,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M957.7,106.4c4.5,0,17.6,2.4,21,0,1.1-.8,2.8-14.5,1-15.9s-19.2-.9-20.3,0C956.3,92.8,957.7,101.3,957.7,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M958.2,106.4c6.8,1.9,9-11.1,11-15.9C962.4,88.5,960.2,101.6,958.2,106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M957.7,97.9v3.5l4.7-10.9C959.5,91.1,959,95,957.7,97.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M957.3,106.8c4.7,0,17.7,2.4,21.3,0,1.5-1,3.7-14.4,1.5-16.7s-20-.9-21.3,0C955.7,92.3,957.3,102,957.3,106.8Zm.8-16c4.3,0,17-2.3,20.2,0,1.1.8,2.7,13.8,1,15.2s-18.5.9-19.6,0C956.7,103.8,958.1,95.6,958.1,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M859.5,142.6c-3.9,0-3.9,5.9,0,5.9S863.3,142.6,859.5,142.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M866.7,142.3c-3.8,0-3.8,5.9,0,5.9S870.5,142.3,866.7,142.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M865.2,139.4c-3.8,0-3.8,5.8,0,5.8S869,139.4,865.2,139.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M862.7,142.5c-3.8,0-3.8,5.9,0,5.9S866.5,142.5,862.7,142.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M865.2,137c-4.7,0,0,4.2,0,4.2S870,137,865.2,137Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M868.1,142.7c.2-1.4-1.1-5.8-3-5.7,2,1.3,4.9,11,.2,10.9C868.4,149.4,871.6,144.7,868.1,142.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M862.4,138c-4.8,0,0,4.2,0,4.1S867.1,138,862.4,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M860.7,139.7c-3.8,0-3.8,5.8,0,5.8S864.5,139.7,860.7,139.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M988.2,143.8c-5.3,0,0,4.8,0,4.7S993.6,143.8,988.2,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M990.6,142.4c-5.4,0,0,4.8,0,4.7S995.9,142.4,990.6,142.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M992,143.8c-5.3,0,0,4.8,0,4.7S997.4,143.8,992,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M996,143.8c-5.3,0,0,4.8,0,4.7S1001.3,143.8,996,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M994.2,140.8c-5.3,0,0,4.7,0,4.6S999.6,140.8,994.2,140.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M993.2,143.7c1.7,2.3-1.2,5.4-3.5,3.8C992.1,150.7,996.6,145.9,993.2,143.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M997.1,141.6c-3,0-3,4.7,0,4.7S1000.1,141.6,997.1,141.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M998.3,144.8c-5.3,0,0,4.7,0,4.7S1003.7,144.8,998.3,144.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M996,139c-5.3,0,0,4.7,0,4.7S1001.3,139,996,139Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M999.2,145c.7-1.4-1.5-6-3.2-6,1.9,1.1,4.7,10.1,1.2,10.1C999.7,150.6,1002.5,146.3,999.2,145Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M839,150h161.5c2.7,0,17.8,2,19.6,0,3.4-3.8-13.4-2.6-14.5-2.6H858.5C854.7,147.4,838.3,144.8,839,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M650.7,52.4c2.4,0,8.2,1.1,9.7-.1s2.7-9.9,3.3-12.1L647.3,40Zm9.3-.2c-10.8-.2-9.3-1.5-12.2-11.8l15.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M660,52.3c-1.2,2.4-7.6.8-9.2,0C649.6,61.7,662.7,60,660,52.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M655.4,0c-25,0-20.5,44.4,0,44.4S680.4,0,655.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M655.4,0c-15.2,0-11.2,44.4,0,44.4S670.6,0,655.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M655.4,0c-6.5,0-4.2,44.4,0,44.4S661.9,0,655.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M638.5,22.1c1.1,8.3,9.5,8.1,16.9,8.1s15.9.2,17-8.6A47.2,47.2,0,0,1,638.5,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M645.3,38.6c3.8,10.8,16.8,10.3,20.5-.4A21.9,21.9,0,0,1,645.3,38.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M888.9,13.8c-4.7-3.8-8.8-3.9-14.5-3.9s-8.4-.5-13-.5-11.1,4.4-15.8,5.4-5.8-2.7-10.7-.5a11.4,11.4,0,0,0-6.7,10.9c.3,11.9,13.9,12.8,22.8,11.3-3,.6,7.7-1.6,8.3-1.5s4.4,2.3,6.8,2.7,6.1-1.1,9.6-1.2c6.7-.1,13,1.9,17.2-5.5C896.1,25.3,893.7,17.8,888.9,13.8Zm-41.6,1.3h-.1C848.5,14.8,848.5,15.1,847.3,15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M610.7,28.8c.1-8.8-10.5-7.6-14.9-8.3s-5.6-3.1-11.2-1.8c-2.6.6-7.1,1.5-9.2,3.6-6.6-19.2-47,14.6-16.7,20.8,5.1,1,11.1-1.1,16.2-.5s9.4,4.9,15.6.7c1.8-1.3,3.1-4.9,4.8-5.6s4.7,1.5,6,1.3C606,38.3,610.9,33.8,610.7,28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.6,147.3c2.2-1.4,1.4-4.6,1.4-8.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M483.5,147.3a22.1,22.1,0,0,0,0-8.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M483.3,111.8c-9.1,0-9.4,30.4,0,30.4S492.4,111.8,483.3,111.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M484.1,112c2.7,4.2,4.7,31.2-4.5,27.3C485.8,149.4,497.3,117.6,484.1,112Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M492.6,147.3c2.5-.9,1.4-4,1.4-7.2h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M493.5,147.3a13.5,13.5,0,0,0,0-7.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M493.3,116.5c-3.5,0-10.5,26.1,0,26.1S496.7,116.5,493.3,116.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M493.6,116.6c2,4.6,8.4,31.2-5.5,23.4.9,3.6,7.8,3.6,9.9,1.2s.4-5.5.3-7.6S497.3,117.9,493.6,116.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M373.9,150H495.8c2,0,12.4,1.5,13.9,0,3.8-3.6-10-2.7-10.6-2.7H388.7C384.9,147.3,373.3,144.9,373.9,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M404.3,99.6h75.5L460.9,82.8C458,80.1,446,65.9,442,65.9s-16.1,14.4-18.9,16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M404.3,147.3h52.5c3.6,0,19.6,2.5,22.4,0s.6-15,.6-18.4,3.1-24.8,0-28.5c-1.7-2.1-10.2-.8-13.4-.8H431.1c-5.3,0-20.6-2.9-25.2,0S404.3,138.6,404.3,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M445.7,147.3c4.8,0,22.9,2.4,25.2-.7,1.2-1.5,0-9.6,0-11.5V113.8c0-6.9,1.8-15.7-1.7-21.3-4.7-7.9-16.6-14.9-23.5-21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.7,109.8c2.9,0,14.7,1.8,16.8,0s1.6-12.1.5-13.3-15-.9-16.2,0S449.7,106,449.7,109.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M450.5,109.1c2.8,0,13.3,1.7,15,0s1.7-10.7.6-11.9-14.3-.7-15,0S450.5,106.3,450.5,109.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M450.9,109.1c5.2,1.2,6.6-8.1,8.3-11.9C454,96,452.5,105.3,450.9,109.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M450.5,102.8v2.6l3.6-8.2C452.3,98,451,100.3,450.5,102.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M458,109.1c1.8-1.4,1.6-10.5,0-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M413.1,147.3c4.5,0,22.4,2.8,25.3,0s0-16.9,0-19.3V71.4c-8.4,7.5-23.5,15.9-25.3,26.8C410.6,113.7,413.1,131.5,413.1,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M417.1,109.8c2.9,0,14.7,1.8,16.8,0s1.7-12.1.5-13.3-15-.9-16.2,0S417.1,106,417.1,109.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M418,109.1c2.7,0,13.2,1.7,15,0s1.6-10.7.5-11.9-14.3-.7-15,0S418,106.3,418,109.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418.3,109.1c5.2,1.2,6.7-8.1,8.3-11.9C421.4,96,420,105.3,418.3,109.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418,102.8v2.6l3.5-8.2C419.7,98,418.4,100.3,418,102.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M425.3,109.1c1.8-1.4,1.6-10.5,0-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M417.1,138.6c2.9,0,14.7,1.8,16.8,0s1.7-12.1.5-13.3-15-.9-16.2,0S417.1,134.8,417.1,138.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M418,137.9c2.7,0,13.2,1.7,15,0s1.6-10.7.5-11.9-14.3-.7-15,0S418,135.1,418,137.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418.3,137.9c5.2,1.2,6.7-8.1,8.3-11.9C421.4,124.8,420,134.1,418.3,137.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418,131.6v2.6l3.5-8.2C419.7,126.8,418.4,129.1,418,131.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M425.3,137.9c1.8-1.3,1.6-10.5,0-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M442,147.3c9.5,0,26.4,3.6,34.9,0,4-1.7,2.9-1.5,2.9-7.4,0-2.7,1.9-16.1,0-18s-30.8-1.2-34.2,0c-5,1.7-3.6-.1-3.6,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M445.7,147.3c4.5,0,22.5,2.8,25.2,0s1.3-24.2,0-25.4-23.9-1.4-25.2,0S445.7,143.2,445.7,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M452.1,147.3c2.6,0,7.8,1.1,10,0s.9,1,2.4-3.1c.8-2,1.4-18.2,0-19.5s-9.1-.5-10,0c-3.3,1.6-.7-.9-2.4,2.2S452.1,142.4,452.1,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.7,143.9c1.4,0,15.6.2,9.2-5.8C458.6,134.2,452.4,138.8,453.7,143.9Zm.3-5.5c1.5,0,14.5-.3,8.6,5.2C458.9,147.1,452.5,143.4,454,138.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M453.9,135c1.8,0,7.2,1,8.4,0s1.2-6.3.4-7-7.4-.4-7.9,0S453.9,132.4,453.9,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M455.5,135c4.4.5,4.6-3.4,6.1-7C457.2,127.4,457,131.3,455.5,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M453.9,131.5v2.6a46.6,46.6,0,0,0,2.6-6.1C454.7,128.3,454.8,129.6,453.9,131.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.3,134.2c-1.8,0-2.7,11.9,0,11.9S448.1,134.2,446.3,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M447.3,139.2c0-2.2-.1,7.5-2,5.7.9,2.7,4.5-8.1,1-10.7A12.4,12.4,0,0,1,447.3,139.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M445.5,147.3c.7-.8,2,.6,1.8-1.7h-2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.3,145.6l.3,1.7C445.6,146.8,445.3,145.9,445.3,145.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M446.7,147.3a4.7,4.7,0,0,0,.6-1.7C446.6,145.9,446.9,146.4,446.7,147.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M470.6,134.2c-1.8,0-2.7,11.9,0,11.9S472.4,134.2,470.6,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M471.6,139.2c0-2.2-.1,7.5-2,5.7.9,2.7,4.5-8.1,1-10.7A12.4,12.4,0,0,1,471.6,139.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M469.8,147.3c.7-.8,2,.6,1.8-1.7h-2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.6,145.6l.3,1.7C469.9,146.8,469.6,145.9,469.6,145.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M471,147.3a4.7,4.7,0,0,0,.6-1.7C470.8,145.9,471.2,146.4,471,147.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442,147.3c7.9,0,7.2,1.3,7.7-6.1.2-3.5-1.5-12.2.7-14.2s35.3,3.6,29.4-4.5c-2-2.6-30-2.1-34.2-.6s-3.2-.3-3.6,6.2S442,140.9,442,147.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M404.3,122.8H442v-.9C434.5,121.9,408.3,118.1,404.3,122.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M404.3,121.9h68c1.1,0,12.2.9,7.5-4.1-1.4-1.4-11.5,0-13.4,0H412.7C408.7,117.8,402.5,115.7,404.3,121.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M404.3,102.1v2.6l19.2-17.1c3.6-3.3,14.4-16.8,19.2-17.2s14.6,12.8,17.5,15.4l19.6,17.3C478,97.4,468.5,91.9,464,87.9c-3-2.7-17.7-19.6-21.9-19.4s-14.9,13.2-17.9,15.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M396.6,100.8c5.8,8.8,13.2-3.6,18.8-8.6l16-14.2c2-1.8,7.4-8.7,10.1-9.1S457.4,82,460.7,85l22.9,20.2c8.9-6-7.9-14.8-12.8-19.1l-17-15c-1.9-1.7-8.6-9.9-11.3-10-4.7-.3-16.3,13.6-20.1,16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.8,147.3c2.6-1.2,1.6-4.3,1.6-7.9h-1.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.8,147.3a15.1,15.1,0,0,0,0-7.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.6,113.7c-3.8,0-11.6,28.6,0,28.5S392.2,113.7,388.6,113.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.9,113.8c2.2,5.2,9.1,34-6,25.5,1,4,8.5,3.8,10.8,1.3s.4-6.6.3-8.8S392.8,115.2,388.9,113.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M398.9,147.3c3.2.2,4.5-10,2.5-12S398.9,145.9,398.9,147.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M400.5,147.3c1.8-1.5,1.5-10.4,0-12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.2,119.2c-13.1,0-13.1,20.3,0,20.4S413.4,119.2,400.2,119.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M405.9,121c6.1,8.9-5.2,20.3-14.2,14.1C400.5,148,419,129.9,405.9,121Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.9,147.3c2.5-1.1,1.6-4,1.6-7.4h-1.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.9,147.3a15.4,15.4,0,0,0,0-7.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.7,115.3c-3.6,0-11,27.2,0,27.2S206.1,115.3,202.7,115.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203,115.4c2.1,4.8,8.8,32.5-5.7,24.3,1,3.8,8.1,3.7,10.2,1.3s.5-5.7.4-7.9S206.8,116.8,203,115.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.7,147.5c2.2-1.4,1.3-4.6,1.3-8.1h-1.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.6,147.5a22.1,22.1,0,0,0,0-8.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.3,112c-9.1,0-9.3,30.3,0,30.3S202.5,112,193.3,112Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.2,112.2c2.6,4.2,4.6,31.2-4.6,27.2C195.9,149.5,207.4,117.7,194.2,112.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.8,140.7c-5.8,0-5.8,8.9,0,8.9S371.5,140.7,365.8,140.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364.9,134.2c-5.8,0-5.8,9,0,9S370.6,134.2,364.9,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.4,127.7c-5.8,0-5.8,9,0,9S369.2,127.7,363.4,127.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.9,127.1c-5.8,0-5.8,9,0,9S361.6,127.1,355.9,127.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358.9,125.2c-5.7,0-5.7,9,0,9S364.7,125.2,358.9,125.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M354.4,121.6c-5.8,0-5.8,9,0,9S360.2,121.6,354.4,121.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M272,147.3c5,0,23.6,2.8,26.6-.3s1.2-28.3,0-29.5-25.2-1.4-26.6,0C268.7,120.8,272,142.2,272,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.6,147.3c5.5,0,18.6,2.1,21.3-1.3,1.1-1.5,1.3-24.2,0-25.6s-20.3-.7-21.3.3C271.6,123.7,274.6,142.5,274.6,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M285.7,146.5c8.1,0,8.1,1.9,9.4-5,.5-2.5,1.7-18.8,0-20.4s-8.1-.4-8.7,0,0,2.3-.7,4.1C283.7,130.8,285.7,140.5,285.7,146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.7,132.7v9.4l9.1-21C288.7,119.4,287.6,128.5,285.7,132.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.7,123.7V127a31.1,31.1,0,0,0,2.6-5.9C286.2,121,286.6,122.2,285.7,123.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.4,146.5c8.1,0,8,1.9,9.4-5,.5-2.5,1.6-18.8,0-20.4s-8.1-.4-8.8,0,0,2.3-.6,4.1C273.4,130.8,275.4,140.5,275.4,146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.4,146.5c2.1-3.8,1.4-8.2,1.4-12.4l-5.4,12.4A17.8,17.8,0,0,0,283.4,146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M277,146.5c2.6-6.1,8.6-14.5,7.8-21.4C283,129.2,274.6,144.9,277,146.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272,147.3c3.7,0,8,.9,9.6-1.4s-1-13.9,0-18.3c1.4-6.3-1.2-4.2,6-4.9,3.2-.4,13.7,2.6,11-3.8-.7-1.7-24.3-3.7-26.6-1.4S272,142.2,272,147.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M207.2,147.3h30.9c9.8,0,9.7,1.4,9.7-8V101.5c0-3.3,2.5-21.5,0-24.1s-26.5,0-30.9,0c-9.8,0-9.7-1.6-9.7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.2,117.5H233c1.7,0,22.2,1.8,14.8-6-2.5-2.6-22,0-25.8,0C215.6,111.5,204.8,108,207.2,117.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.2,79.2h23.1c1.8,0,19.3.3,17.5-1.8s-19.9,0-23.1,0S207.6,75.5,207.2,79.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.3,109.6h13.8c3.9,0,16.8,2.2,20.1,0s4.2-23.3,1.6-26.2-31.1-1.3-33.4,0C207.6,86.3,210.3,102.7,210.3,109.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M211.1,108.8H224c4,0,15.9,2.1,19.3,0,1.8-1.2,4.4-21.8,1.6-24.5s-28.8-1.4-31.6,0C208.5,86.8,211.1,102.1,211.1,108.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.7,108.8c7.2,2.1,12.2-19.1,14.5-24.5C236,82.1,231,103.4,228.7,108.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M224.8,108.8c5.2-1.4,9.5-19,11.9-24.5C231.5,85.7,227.2,103.3,224.8,108.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.3,145.1h13.8c3.9,0,16.8,2.2,20.1,0s4.2-23.3,1.6-26.2-31.1-1.4-33.4,0C207.6,121.8,210.3,138.2,210.3,145.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M211.1,144.3H224c4,0,15.9,2.1,19.3,0,1.8-1.2,4.4-21.8,1.6-24.5s-28.8-1.4-31.6,0C208.5,122.3,211.1,137.6,211.1,144.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.7,144.3c7.2,2.1,12.2-19.1,14.5-24.5C236,117.6,231,138.8,228.7,144.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M224.8,144.3c5.2-1.4,9.5-19,11.9-24.5C231.5,121.2,227.2,138.7,224.8,144.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.2,121.1h23.1c1.5,0,22.3,1.4,17.5-3.6-2.3-2.4-19.7,0-23.1,0S205.5,114.6,207.2,121.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M298.6,147.3c16.4,0,33.7,1.8,50,0,7.4-.8,5.8-.1,5.8-8.6,0-3.4,2.4-22.4,0-24.4s-16.4,0-19.6,0c-10,0-20.5-1.1-30.4,0-7,.7-5.8-.8-5.8,7.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.1,114.3c1.5,7.6-26.2.8-31.4,3.2s3.5,1.7,5,1.8a150.9,150.9,0,0,0,22.3,0c1.1,0,2.9.4,4.1,0s1.2-3,2-3.3c5.7-1.7,12.9,1.4,18.8,0s-1.4-1.7-4.3-1.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M307.5,147.3h14.4c4.1,0,17.5,2.2,21,0s4.4-24,1.6-27-32.1-1.4-34.8,0C304.7,122.9,307.5,140.4,307.5,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,123.9c11.7,0,26.1,1.9,37-.4C332.8,123.5,318.4,121.6,307.5,123.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,127.9c11.7,0,26.1,1.9,37-.3C332.8,127.6,318.4,125.7,307.5,127.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,131.9c11.7,0,26.1,1.9,37-.3C332.8,131.6,318.4,129.7,307.5,131.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,136c11.7,0,26.1,1.9,37-.4C332.8,135.6,318.4,133.7,307.5,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,140h37C335,138.1,316.9,137.7,307.5,140Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M307.5,144c11.7,0,26.1,1.9,37-.3C332.8,143.7,318.4,141.8,307.5,144Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.5,147.3c3.6-4.8-3.1-22.9,1.8-26.2,3.2-2.2,14.6,0,18.5,0h16.7c-3.6-2.5-29.9-3.3-34.8-.8S307.5,140.3,307.5,147.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M331.1,114.3h15.8c.8,0,14.6,1.1,10.5-3.1-1.5-1.5-12.3,0-14.5,0S329.9,108.8,331.1,114.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M331.1,114.3c.2-.9,1.9-1.8,0-3.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M199.3,77.4H324c2,0,12.8,1.6,14.4,0,4.3-4.1-10.5-3-11-3H213.8C210,74.4,198.2,71.8,199.3,77.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M272,77.4C276.4,76,272.2,71.8,272,77.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272,117.5h35c1.8,0,32.2,2.3,24.1-6-3.5-3.6-28.7,0-33.7,0C290.6,111.5,269.1,106.6,272,117.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272,117.5c3.2,1,8.4-2.2,5-6S271.3,115,272,117.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M272,81.2h33.6c2,0,30.2,1.3,25.5-3.8-3.2-3.3-27.8,0-32.4,0S270,74,272,81.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M323.6,117.5c9.8,0,7.5-1.9,7.5-11.5,0-3.6,2.5-22.2,0-24.8-.8-.8-7.2-.1-7.5.2s0,8.3,0,10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272,81.2c4.1,1.1,4.4-1.5,7.8-2,5.9-1,12.7,0,18.7,0,3.7,0,32.7-1.1,32.6-1.3-2.3-3.3-27.9-.5-32.4-.5S270.1,74,272,81.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M272,111.5c14.7,0,31.9,2.6,46.4,0,6.9-1.2,5.2,0,5.2-8.7,0-3.3,2.2-19.5,0-21.6s-15,0-17.7,0c-9.1,0-18.8-1-27.8,0-7,.7-5.8-1.2-6.1,6.3S272,103.5,272,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.2,111.5c13,0,29.2,2.9,41.7,0,6.1-1.3,4.9.5,4.9-7.2,0-3.1,2.1-18.6,0-20.6s-14.1,0-16.4,0c-8,0-16.5-.9-24.4,0s-5.3-1.2-5.8,6S274.2,104.3,274.2,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M274.9,110.9c5.6,0,19.5,2.2,22.2-1.3,1.1-1.5,1.3-23.8,0-25.3s-21.3-.7-22.2.3C271.9,87.7,274.9,106.1,274.9,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M294.9,110.9c2.7-4.6,2.2-9.3,2.2-14.5l-6.2,14.5A17.8,17.8,0,0,0,294.9,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M288.4,110.9c2.8-6.6,9.6-16.2,8.7-23.5C295.1,91.9,285.8,109.2,288.4,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M297.9,110.9c5.6,0,19.5,2.2,22.2-1.3,1.1-1.5,1.3-23.8,0-25.3s-21.3-.7-22.2.3C294.9,87.7,297.9,106.1,297.9,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M317.9,110.9c2.7-4.6,2.2-9.3,2.2-14.5l-6.2,14.5A17.8,17.8,0,0,0,317.9,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M311.4,110.9c2.8-6.6,9.6-16.2,8.7-23.5C318.1,91.9,308.8,109.2,311.4,110.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272,111.5c9.9,0,9.6,1.2,9.6-8.6,0-5.5-1.9-14.3,2-16.6s20.2,0,25.7,0c1.7,0,19.9,2,14.3-4.5-1.9-2.2-13-.6-16.4-.6-9.6,0-19.6-.9-29.1,0-7.2.6-5.7-1.1-6.1,6.3S272,103.6,272,111.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M307.7,111.5c2.8,0,13.5,1.7,15.3,0s1.6-9.3.6-10.4-12.9-.6-13.9,0C306.5,102.9,307.7,106.7,307.7,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M272,111.5c1.7,0,10.2,1.1,11.4,0s1.2-9.6.4-10.4-10.5-.6-11.2,0S272,108.8,272,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M284.2,111.5c5.7,0,13.4,1.5,18.9,0,2-.5,3.2.6,4.2-.8s.6-9,0-9.6-15.7-.4-17.9,0C282.1,102.2,284.2,103,284.2,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M283.8,111.5a26,26,0,0,0,0-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M307.3,111.5a30.3,30.3,0,0,0,0-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M272,101.1h27.1c5.2,0,21,2.3,24.5-.8H296.4C291.3,100.3,275.4,98,272,101.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272,111.5c5.8,1.7,8.3-7.8,5-11.2C271.1,94.1,272,109.9,272,111.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M244.9,70.6h17.8c.8,0,16.5.8,12.1-3-2.1-1.9-13.3,0-16.3,0S243.7,65.1,244.9,70.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M247.8,147.3c4.1,0,22,2.4,24.2-.1s0-19.1,0-22.3V90.5c0-2.8,2-17.7,0-19.9s-22.8-1.3-24.2.1,0,16.7,0,19.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247.8,72.3c3,0,25.4,0,24.2-1.7S248,70.5,247.8,72.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.1,109c5.6,1,3.4-5.6,3.4-9.8,0-2.5,1.7-12.9,0-14.9-4.1-5-3.4,9.3-3.4,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M265.1,99.2c1.5-3.7,4-7.6,3.4-11.8C266.9,91.2,264.5,95,265.1,99.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.1,109c5-2.4-2.9-23.4,3.4-23.5V84.3C261.9,83.1,265.1,103.7,265.1,109Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.1,143.2c5.6,1.1,3.4-5.6,3.4-9.7,0-2.6,1.7-13,0-15-4.1-4.9-3.4,9.4-3.4,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M265.1,133.5c1.5-3.8,4-7.6,3.4-11.9C266.9,125.4,264.5,129.2,265.1,133.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.1,143.2c5-2.3-2.9-23.3,3.4-23.5v-1.2C261.9,117.3,265.1,137.9,265.1,143.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M250.2,83.4C259.2,85,252.1,78.4,250.2,83.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M256.7,101C265.8,102.6,258.7,95.9,256.7,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M255,134.4C264,136,256.9,129.4,255,134.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M251.5,106.1C260.6,107.7,253.5,101.1,251.5,106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.4,132.4c-5.9,0-5.9,9,0,9S366.2,132.4,360.4,132.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M356.8,130.6c-6.5,0,0,5.8,0,5.7S363.4,130.6,356.8,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M354.4,134.1c-5.2,0-5.2,8.1,0,8.1S359.6,134.1,354.4,134.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M361.9,138.7c-5.8,0-5.8,9,0,9S367.7,138.7,361.9,138.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M356.8,138.3c-6.9,0-6.9,10.8,0,10.8S363.9,138.3,356.8,138.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.2,139.9c-5.3,0-5.3,8.3,0,8.3S357.6,139.9,352.2,139.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.2,139.3c2.6-4.1-6.1-10.2-9-8.1,5.9-.7,13.7,12.9,7.6,16.4A4.5,4.5,0,0,0,364.2,139.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M182.3,150H358.9c3.2,0,19.4,2.3,21.7,0s-15.4-2.7-16.5-2.7H204C200,147.3,181.6,144.6,182.3,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.2,147.3c2-1,1.2-3.9,1.2-6.8H12.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13,147.3a19.4,19.4,0,0,0,0-6.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.8,117.6c-7.6,0-7.8,25.4,0,25.4S20.5,117.6,12.8,117.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.5,117.7c2.2,3.6,3.9,26.2-3.8,22.9C14.9,149,24.8,122.5,13.5,117.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.6,147.3c2.1-1.3,1.3-4.3,1.3-7.6H29.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.5,147.3a24.2,24.2,0,0,0,0-7.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.2,114c-8.5,0-8.8,28.5,0,28.5S38.8,114,30.2,114Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31,114.1c2.5,4,4.4,29.4-4.2,25.6C32.6,149.2,43.4,119.4,31,114.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20.5,147.3c2.3-1.4,1.4-4.6,1.4-8.1H20.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.5,147.3a22.1,22.1,0,0,0,0-8.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.2,111.8c-9.1,0-9.3,30.4,0,30.4S30.4,111.8,21.2,111.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.1,112c2.6,4.2,4.6,31.2-4.6,27.3C23.8,149.4,35.3,117.6,22.1,112Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M0,150H164.5c3,0,17.3,2.1,19.5,0,3.8-3.6-13.6-2.7-14.4-2.7H20.4C16.6,147.3-.7,144.7,0,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.8,147.3c2.3-1.4,1.4-4.6,1.4-8.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.8,147.3a22.1,22.1,0,0,0,0-8.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.5,111.8c-9.1,0-9.3,30.4,0,30.4S172.7,111.8,163.5,111.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.4,112c2.6,4.2,4.6,31.2-4.6,27.3C166.1,149.4,177.6,117.6,164.4,112Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.7,147.3c3.2.2,4.6-10,2.5-12S170.7,145.9,170.7,147.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.4,147.3c1.6-2.2.8-8.3.8-12C171.6,137.5,172.4,143.6,172.4,147.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172,119.2c-13.1,0-13.1,20.3,0,20.4S185.2,119.2,172,119.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.7,121c6.1,8.9-5.2,20.3-14.2,14.1C172.4,148,190.8,129.9,177.7,121Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M32.2,147.3c5.1,0,23.6,2.8,26.8-.3,1.3-1.3,1.4-29.1,0-30.3s-25.4-1.1-26.8.3C28.9,120.2,32.2,142.2,32.2,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M28.9,116.7h19c1.2,0,16.3,1.5,11.1-4.3-1.5-1.7-15.3,0-17.7,0C37.2,112.4,26.6,109.6,28.9,116.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M28.9,112.4c5.3,0,26.4,3.3,29.8,0,1.6-1.5,1.8-24.2.3-25.8s-26.9-1.4-28.9,0C26.5,89,28.9,107,28.9,112.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.2,118.4H48.3c.7,0,13.1.3,10.7-1.7S32.8,116.4,32.2,118.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.2,137.3c2.9,0,14.3,1.8,16.2,0s1.8-11.4.6-12.5-15.4-.8-16.2,0S37.2,134.3,37.2,137.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M38.2,136.3c2.9,0,11.8,1.7,14.2,0,.6-.5,1.6-9.6.6-10.6s-13.5-.5-14.2,0S38.2,133.8,38.2,136.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M40.6,136.3c5.1,1,6.1-6.7,7.7-10.6C43.3,124.8,42.2,132.5,40.6,136.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M38.2,134.9c.2.8-.5,1.3.5,1.4l4.5-10.6C40.6,127.3,39.6,131.6,38.2,134.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.6,136.3c.9-2.2.9-8.3,0-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M132.3,147.3c5.2,0,23.6,2.8,26.9-.3,1.3-1.3,1.3-29.8,0-30.9s-25.4-1.1-26.9.3C129,119.6,132.3,142.1,132.3,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M132.3,111.8c5.3,0,26.5,3.3,29.8,0,1.6-1.5,1.8-24.2.3-25.8s-26.9-1.4-28.9,0C129.9,88.4,132.3,106.4,132.3,111.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M132.3,116.1h19c1.2,0,16.3,1.5,11.1-4.3-1.5-1.7-15.3,0-17.6,0C140.6,111.8,130.1,109,132.3,116.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,117.8h16.1c.7,0,13.2.3,10.8-1.7S133,115.8,132.3,117.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,147.3c4.8.5,2.6-8.4,2.6-12s2.1-15.3,0-17.5-2.6,9.9-2.6,10.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.4,136.7c2.9,0,14.3,1.8,16.2,0s1.8-11.4.5-12.6-15.3-.7-16.1,0S137.4,133.7,137.4,136.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M138.4,135.7c2.8,0,11.8,1.7,14.1,0,.7-.5,1.7-9.6.7-10.6s-13.5-.5-14.2,0S138.4,133.1,138.4,135.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M140.8,135.7c5,.9,6-6.8,7.7-10.6C143.4,124.2,142.4,131.9,140.8,135.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M138.4,134.2c.2.9-.5,1.4.5,1.5l4.5-10.6C140.8,126.6,139.7,131,138.4,134.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.8,135.7c.9-2.2.9-8.4,0-10.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,111.8c2.5-1.5,3.5-5.8,4.8-9C130.3,100.8,132.3,107.2,132.3,111.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,102.8c5,0,6.6,1,8.4-2.1.4-.8.9-13.7,0-14.6-2.6-2.7-7.7,1-8.4,2.1C130.6,91.1,132.3,99.3,132.3,102.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,116.1c.6-.9,1.7-1.8,1.1-4.3h-1.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M53.3,101.7h63.6c3.7,0,18.5,2.1,21.1-.3s1.3-27.5,0-28.8-18,0-21.1,0H74.4c-2.6,0-19.1-2-21.1,0S53.3,96.7,53.3,101.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M95.6,89.7C90.2,94.2,83.5,102.4,77,105c-4.5,1.8-15.3-2.2-18,1.1s0,24.1,0,29.5c0,2-1.2,9.6,0,11.1s1.7,0,3.2.6c6.9,2.7,20.6,0,28,0h32.7c7.8,0,7.8,1.9,9.4-4.2,2.3-8.7.8-22.8,0-31.8-.2-3.1.7-4.7-1.1-6s-12.1,1.3-16.1,0C108.3,102.9,101.3,94.3,95.6,89.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M104.5,147.3c4.7-1.1,1.6-46.2,1.6-53.4h-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M85.1,147.3c4.7-1.1,1.7-46.2,1.7-53.4H85.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.6,89.7C90,94.2,83.4,102.3,76.9,105c-2.8,1.2-18.2-1.4-17.9,1.4s16.6,2,19.2.9c5.6-2.4,12.1-15.5,18-15.8s12.8,13,18,15.1c2.4,1.1,17.7,2.2,18.1.4.9-3.9-15.1-.8-18.1-2C107.8,102.4,101,94.1,95.6,89.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.9,101.6h11.5L95.6,84.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.6,100c-6.1,0-6.8,8.6-5.9,13.1s-.9,4.8,5.9,4.7,4.8,1.1,5.9-4.7S101.8,100,95.6,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M95.6,101c-5.4,0-5.2,6.6-4.9,10.4s-.9,5.5,4.9,5.4,4.1.4,5-5.4C101.1,107.6,100.9,101,95.6,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.3,116.8c1.8-3.4.6-11.4.6-16C94.2,104.2,95.3,112.2,95.3,116.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.7,112.6c3.2,0,7.7.3,9.9-.6C97.4,112,92.9,111.8,90.7,112.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.7,107.8c3.2,0,7.7.3,9.9-.6C97.4,107.2,92.9,106.9,90.7,107.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.8,147.3c5.5,0,11.6,1.6,13.7-2.2.8-1.5,1.2-19.3,0-20.4s-12.8.1-13.7,1.4C86.4,129.6,88.8,142.7,88.8,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M90.6,139.6c2.5,0,8.8,1,10.1-.5s.6-12.3,0-12.8-9.7.2-10.1.6S90.6,137.4,90.6,139.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M90.6,145.5c.9,0,15.2.9,10.1-3.9C98,139,89.4,140.7,90.6,145.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M90.6,139c4.1,3,7.2-9.2,8.7-12.7C93.9,125.3,92.3,134.9,90.6,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M90.6,131.9v2.6l3.5-8.2C92.4,127.1,91.1,129.4,90.6,131.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M108.9,117.8c3.4,0,11.8,1.7,14.7,0,1.2-.7,5.1-5.1,2.1-8-1.1-1.1-13.7-.5-14.6,0C108.1,111.5,108.9,113,108.9,117.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M109.9,116.8c1.9,0,22.6,1,14.8-6-.7-.7-11.7-.4-12.5,0S108.5,111.9,109.9,116.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M111.7,116.8c3.8.4,4.8-2.4,5.8-6C113.6,110.4,112.6,113.2,111.7,116.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M109.9,113.8v2.6c1.1-1.5,1.8-3.9,2.5-5.6C110.5,110.9,110.8,112.2,109.9,113.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.4,117.8c3.4,0,11.7,1.7,14.7,0,1.2-.7,5-5.1,2.1-8-1.1-1.1-13.8-.5-14.7,0C64.5,111.5,65.4,113,65.4,117.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M66.4,116.8c1.9,0,22.6,1,14.8-6-.7-.7-11.8-.4-12.5,0C66.3,112.1,65,111.9,66.4,116.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M68.2,116.8c3.8.4,4.8-2.4,5.7-6C70.1,110.4,69.1,113.2,68.2,116.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M66.4,113.8v2.6a27.8,27.8,0,0,0,2.4-5.6C66.9,110.9,67.2,112.2,66.4,113.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M108.9,137c2.9,0,14.4,1.8,16.2,0s1.8-11.4.6-12.5-15.4-.8-16.2,0S108.9,134,108.9,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M109.9,136c2.9,0,11.9,1.7,14.2,0,.7-.5,1.6-9.6.6-10.6s-13.4-.5-14.1,0S109.9,133.5,109.9,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M112.3,136c5.1,1,6.1-6.7,7.8-10.6C115,124.5,114,132.2,112.3,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M109.9,134.6c.3.8-.4,1.3.5,1.4l4.6-10.6C112.3,127,111.3,131.3,109.9,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.3,136c1-2.2,1-8.3,0-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.4,137c2.9,0,14.3,1.8,16.2,0s1.8-11.4.6-12.5-15.4-.8-16.2,0S65.4,134,65.4,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M66.4,136c2.9,0,11.8,1.7,14.2,0,.6-.5,1.6-9.6.6-10.6s-13.5-.5-14.2,0S66.4,133.5,66.4,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M68.8,136c5.1,1,6.1-6.7,7.7-10.6C71.5,124.5,70.4,132.2,68.8,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M66.4,134.6c.2.8-.5,1.3.5,1.4l4.5-10.6C68.8,127,67.8,131.3,66.4,134.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.8,136c.9-2.2.9-8.3,0-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M95.6,84.4c-5.5,4.7-13.2,14.6-19.9,17s-19.6-2.9-22.4,1.2,20.1,4.1,23.7,2.9C82.9,103.6,89.7,90,95.6,90s12.7,13.5,18.7,15.5c3.4,1.2,25.9,1.2,23.7-2.9s-17.6.6-22.4-1.2C108.9,98.9,101.1,89.1,95.6,84.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.2,28.6c-4.7-2.3-10-2.1-15.1-1.2,1.4-.3-6.2,1.2-8,1-6.9-.7-14-3.1-21.3-1.8-19.2,3.6-6.6,23.8,6.7,24.9,4.8.4,12.3.9,16.9-.1s7.3-3.7,10.7-4.4,7.5,3.8,12.8-1.9S144.3,31.6,138.2,28.6Zm-11.7,18h.1C125.4,47,125.4,46.6,126.5,46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M278.2,26.8c-1.4-6.2-7.1-3.7-10.8-3.6s-8.5-1.1-11.3,3.3c.4-.6-3.1-4.2-5.5-4.8s-8.1,2.5-10.2,5.4c-6.4,9-.6,14.6,8.2,14.9s17.7,2.3,25.1.3S290.8,29.3,278.2,26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M369.3,73c11.3.3,9.7-1.1,12.7-11.8L366,61Zm9.1-.2c-10.5-.2-9.1-1.4-11.9-11.4l15,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M378.4,72.9c-1.2,2.3-7.4.8-9,0C368.3,82,381,80.4,378.4,72.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M373.9,22.1c-24.3,0-19.9,43.1,0,43.1S398.2,22.1,373.9,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M373.9,22.1c-14.8,0-10.9,43.1,0,43.1S388.6,22.1,373.9,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M373.9,22.1c-6.3,0-4,43.1,0,43.1S380.1,22.1,373.9,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M364.1,59.6c3.6,10.5,16.3,10,19.9-.4A21.2,21.2,0,0,1,364.1,59.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.80ec15a74221cd23ff641221e0b4e622.svg";
export { ForwardRef as ReactComponent };